export default __webpack_public_path__ + "static/media/slide1.434d1961.png";